(() => {
  const script = document.querySelector('script[data-fm-image-map]');
  const main = document.getElementById('MainContent');
  if (!script || !main) return;
  fetch(script.dataset.fmImageMap).then(r => { if (!r.ok) throw new Error('images'); return r.json(); }).then(mapping => {
    const update = () => main.querySelectorAll('img').forEach(img => {
      const source = img.getAttribute('src') || img.getAttribute('data-src');
      if (!source || source.startsWith('data:')) return;
      let filename;
      try { filename = decodeURIComponent(new URL(source,location.origin).pathname.split('/').pop()).replace(/_\d+x\d*(?=\.[^.]+$)/, ''); } catch { return; }
      const target = mapping[filename];
      const neutral = (target || source).includes('filamelt-compact-series-neutral');
      if (neutral) {
        const card = img.closest('.spf-product-card, .card-wrapper');
        const info = card?.querySelector('.spf-product__info, .card__information');
        if (info && !info.querySelector('.fm-series-image-note')) {
          const note = document.createElement('p'); note.className = 'fm-series-image-note';
          note.textContent = script.dataset.fmSeriesNote; info.appendChild(note);
        }
      }
      if (!target) return;
      const srcset = [320,640,960,1600].map(width => target + '?width=' + width + ' ' + width + 'w').join(', ');
      img.setAttribute('src', target + '?width=960');
      img.setAttribute('srcset', srcset);
      if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset',srcset);
      if (img.hasAttribute('data-src')) img.setAttribute('data-src',target + '?width={width}');
      img.width = 1600; img.height = 1600;
      if (img.classList.contains('spf-product-card__image-main')) img.closest('.spf-product-card')?.classList.add('fm-card-cutout');
    });
    let queued = false;
    new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); }).observe(main,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset']});
    update();
  }).catch(() => {});
})();
